



























































































import mixins from 'vue-typed-mixins';
import LogUtils, { Log } from '@/utils/LogUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => Log,
    },
  },
  data(): {
    log?: Partial<Log>;
  } {
    return {
      log: undefined,
    };
  },
  computed: {
    id(): number | undefined {
      const id = parseInt(this.$route.params.id);
      return !isNaN(id) ? id : undefined;
    },
  },
  async mounted() {
    this.$loading(true);
    try {
      if (this.id) {
        const resp = await Promise.all([LogUtils.api.instance.get(this.id)]);
        this.log = resp[0];
      }
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
    this.$loading(false);
  },
});
